import SingUp from './sign-up';

import { createContainer } from '@dbk-legacy/muster/react';

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    auth: {
      langCode: true,
    }
  },
})(SingUp);
